var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.724 1.66678C6.12396 1.66678 2.39062 5.40011 2.39062 10.0001C2.39062 14.6001 6.12396 18.3334 10.724 18.3334C15.324 18.3334 19.0573 14.6001 19.0573 10.0001C19.0573 5.40011 15.324 1.66678 10.724 1.66678ZM10.724 14.1668C10.2656 14.1668 9.89063 13.7918 9.89063 13.3334V10.0001C9.89063 9.54178 10.2656 9.16678 10.724 9.16678C11.1823 9.16678 11.5573 9.54178 11.5573 10.0001V13.3334C11.5573 13.7918 11.1823 14.1668 10.724 14.1668ZM11.5573 7.50011H9.89063V5.83345H11.5573V7.50011Z",
    fill: "#00A7E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.614f242d76c1861ac1bb3b8d9efdab33.svg";
export { ForwardRef as ReactComponent };